import { render } from "./SettingsContainer.vue?vue&type=template&id=6213dc21&scoped=true&ts=true"
import script from "./SettingsContainer.vue?vue&type=script&lang=ts"
export * from "./SettingsContainer.vue?vue&type=script&lang=ts"

import "./SettingsContainer.vue?vue&type=style&index=0&id=6213dc21&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6213dc21"]])

export default __exports__